import './PurchasedListItemDetails.scss'

import React, { useState } from 'react'

import { Icon, Button } from 'hb4e-ui-core-ui'

import ListItemDownloadButton from '../../../../ListItemActions/ListItemDownloadButton/ListItemDownloadButton'
import SupplementPanel from './SupplementPanel/SupplementPanel'
import { getProductDetailsForListItem, hasExpirationDate } from '../../../../../../list-service'

// Must be used within list-view__list-details in ListView.jsx
const PurchasedListItemDetails = ({ item, list }) => {
  // Do not render the item if it does not have any product returned from BE (product may have been removed from catalog or retired)
  if (!item.product) {
    return null
  }

  const [isSupplementsPanelExpanded, setIsSupplementsPanelExpanded] = useState(false)
  const {
    expirationDate,
    isExpired,
    productAuthors,
    productImage,
    productLength,
    productLengthLabel,
    productTitle,
    productType,
    signpost,
    hasSupplements,
  } = getProductDetailsForListItem(item)

  const hasLengthValue = !!productLength
  const isExpiredClass = isExpired ? 'is-product-expired' : ''
  const { product } = item

  const renderExpiredStatus = () => {
    return (
      <div className="purchased-list-item-details__status-container">
        <span className="purchased-list-item-details__status is-expired">Expired</span>
        <div className="purchased-list-item-details__status-text">This item is no longer accessible</div>
      </div>
    )
  }

  const renderSupplementsPanel = (product) => {
    return (
      <>
        <div className="purchased-list-item-details__expand-button-container">
          <Button
            data-testid="expand-supplements-button"
            theme="primary link icon-right"
            icon={isSupplementsPanelExpanded ? <Icon.CircleChevronUp /> : <Icon.CircleChevronDown />}
            className="purchased-list-item-details__expand-button"
            onClick={() => setIsSupplementsPanelExpanded(!isSupplementsPanelExpanded)}
          >
            Supplements
          </Button>
        </div>
        <div className="purchased-list-item-details__product-supplements">
          <SupplementPanel product={product} item={item} isExpanded={isSupplementsPanelExpanded} />
        </div>
      </>
    )
  }

  return (
    <div className="purchased-list-item-details">
      <div className="purchased-list-item-details__container">
        {isExpired && <div className="purchased-list-item-details__product-status">{renderExpiredStatus()}</div>}
        <div className="purchased-list-item-details__image-container">
          <img className="purchased-list-item-details__preview-image" src={productImage} alt="" />
        </div>
        <div className="purchased-list-item-details__product-type">
          <span className={`purchased-list-item-details__product-type-category ${isExpiredClass}`}>{productType}</span>
          {signpost && <span className="purchased-list-item-details__product-type-signpost">{signpost}</span>}
        </div>
        <h3 className={`purchased-list-item-details__title ${isExpiredClass}`}>{productTitle}</h3>
        <div className={`purchased-list-item-details__authors ${isExpiredClass}`}>By: {productAuthors}</div>
        <div className="purchased-list-item-details__info">
          {hasExpirationDate && (
            <div className={`purchased-list-item-details__info-expiration-date ${isExpiredClass}`}>
              <span className="purchased-list-item-details__expiration-date-key">Expiration Date: </span>
              <span className="purchased-list-item-details__expiration-date-value">{expirationDate}</span>
            </div>
          )}
          {hasLengthValue && (
            <div className={`purchased-list-item-details__info-pages ${isExpiredClass}`}>
              <span className="purchased-list-item-details__pages-key">{productLengthLabel}: </span>
              <span className="purchased-list-item-details__pages-value">{productLength}</span>
            </div>
          )}
        </div>
        <div className="purchased-list-item-details__action-buttons">
          <ListItemDownloadButton item={item} product={item.product} list={list} isDisabled={isExpired} />
        </div>
        {hasSupplements && renderSupplementsPanel(product)}
      </div>
    </div>
  )
}

export default PurchasedListItemDetails
